import styled, { css } from "styled-components";
export const TagInside = styled.section `
	width: 100%;
	min-height: 2.5rem;
	${(props) => {
    if (props.isFixed) {
        return css `
				position: fixed;
				left: 0;
				z-index: 30;
				top: ${props.scrollTop}px;
			`;
    }
    return css `
			position: static;
		`;
}}

	> ul {
		height: inherit;
		padding: 0.1875rem 0.25rem;

		> li {
			display: block;
			padding: 0.25rem 0 0.1875rem 0;
			border-radius: 2px;
			text-align: center;
			p {
				font-family: "SFProText-Medium";
				font-weight: 500;
				color: #666;
			}
			> p:first-child {
				font-size: 0.8125rem;
				line-height: 0.9375rem;
			}
			> p:nth-child(2) {
				font-size: 0.75rem;
				line-height: 0.75rem;
				transform: scale(0.83);
				margin-top: 0.0625rem;
			}
		}

		li.activeTab {
			color: #fff;
			background: linear-gradient(129deg, rgba(254, 69, 106, 1) 0%, rgba(227, 13, 5, 1) 100%);
			p {
				color: #fff;
			}
			* {
				color: #fff;
			}
		}
	}

	.averageTag {
		display: flex;
		justify-content: space-between;
		li.tab {
			width: 100%;
		}
	}

	.moreTag {
		display: flex;
		width: auto;
		white-space: nowrap;
		overflow-x: scroll;
		&::-webkit-scrollbar {
			height: 0;
		}
		li.tab {
			flex-basis: 6.875rem;
			flex-shrink: 0;
			flex-grow: 0;
		}
	}
`;
export const TagOutside = styled.section `
	width: 100%;
	height: 2.5rem;
	margin-top: 0.75rem;
	display: inline-block;
`;
